import { useState, memo } from "react";
import React from "react";
import { ReactComponent as ArrowUpIcon } from "../../assets/icons/arrow_drop_up.svg";
import { ReactComponent as ArrowDownIcon } from "../../assets/icons/arrow_drop_down.svg";
import { motion, AnimatePresence } from "motion/react"
import { APP_CONFIG } from "constants/constants";

const Collapse: React.FC<{
    textOpen: string;
    textClosed: string;
    hideToggleArrow?: boolean;
    icon: React.ReactNode;
    children: React.ReactNode;
}> = ({ textOpen, textClosed, icon, hideToggleArrow = false, children }) => {
    const [isOpen, setIsOpen] = useState(false)
    const toggleCollapse = () => {
        setIsOpen(!isOpen);
    }
    return (
        <div className="bg-gray-100 rounded-md p-2">
            <div className="flex flex-row cursor-pointer items-center min-h-[26px] gap-x-1" onClick={toggleCollapse}>
                <span className="[&>svg]:fill-blue-500 shrink-0">{icon}</span>
                <span className="text-blue-500 select-none flex-1">{isOpen ? textOpen : textClosed}</span>
                {hideToggleArrow ? <></> : <span className={`[&>svg]:fill-blue-500 shrink-0`}>{isOpen ? <ArrowUpIcon /> : <ArrowDownIcon />}</span>}
            </div>
            <AnimatePresence initial={false}>
            {isOpen && (
                <motion.div
                key="collapse-content"
                initial={{ opacity: 0, height: 0 }}
                animate={{ opacity: 1, height: "auto" }}
                exit={{ opacity: 0, height: 0 }}
                transition={{
                    opacity: { duration: isOpen ? APP_CONFIG.SHORT_EXIT_ANIMATION_DURATION : APP_CONFIG.FAST_ANIMATION_DURATION },
                    height: { duration: isOpen ? APP_CONFIG.SHORT_EXIT_ANIMATION_DURATION : APP_CONFIG.FAST_ANIMATION_DURATION }
                }}
                className="pt-2 gap-y-2 flex flex-col overflow-hidden"
                >
                {children}
                </motion.div>
            )}
            </AnimatePresence>
        </div>
    );
}

export default memo(Collapse)

